import React from "react";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import { ModalComponent } from "./ModalComponent"
import { useEffect } from "react";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import AdminRequestModal from "./ehocm/AdminRequestModal";
import EhocmWithdrawModal from "./ehocm/EhocmWithdrawModal";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    callback: (programContainer: ProgramContainer) => void;
    programContainer: ProgramContainer;
    onButtonClick?: (data: any) => Promise<void>;
}

const FieldModalComponent = ({ field, isEng, callback, programContainer, onButtonClick }: Props) => {
    useEffect(() => {
        if (field.Script) {
            FormValidationUtils.runJavascript(field);
        }
    }, []);
    return (
        <>
            {field.LoadBindName?.toLocaleLowerCase() === 'ehocmadminapprovaldeny' && (
                <AdminRequestModal
                    field={field}
                    isEng={isEng}
                    callback={callback}
                    programContainer={programContainer}
                    onButtonClick={onButtonClick}
                />
            )}
            {field.LoadBindName?.toLocaleLowerCase() === 'withdrawapplicationmodal' && (
                <ModalComponent
                    modalIsOpen={field?.Value === 'Withdraw'}
                    onRequestClose={() => { field.Value = null; callback(programContainer); }}
                    shouldCloseOnOverlayClick={false}
                >
                    <EhocmWithdrawModal
                        token={getRootComponent(field)?.Profile?.token}
                        programContainer={getRootComponent(field)}
                        isEng={isEng}
                        field={field}
                        onButtonClick={onButtonClick}
                        onRequestClose={() => { field.Value = null; callback(programContainer); }}
                    />
                </ModalComponent>
            )}
        </>
    )
}

export default FieldModalComponent